import { render } from "./401.vue?vue&type=template&id=f8e2cdde&scoped=true&ts=true"
import script from "./401.vue?vue&type=script&lang=ts"
export * from "./401.vue?vue&type=script&lang=ts"

import "./401.vue?vue&type=style&index=0&id=f8e2cdde&scoped=true&lang=css"

import exportComponent from "E:\\project\\ale\\建大车辆入校预约\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8e2cdde"]])

export default __exports__